/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-01-25 16:42:54
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-08 16:15:06
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/SingleCollapse/Collapse.tsx
 */
import React from 'react';

import css from './css.less';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const SingleCollapse = (props) => {
  const { children, open, header, className, setOpen, id } = props;
  return (
    <Collapse
      onChange={(e) => {
        if (e.length > 0) {
          setOpen(true);
        } else {
          setOpen(false);
        }
      }}
      activeKey={open ? ['1'] : []}
      ghost
      className={`${css.container} ${className || ''}`}>
      <Panel header={header} key='1' id={id}>
        {children}
      </Panel>
    </Collapse>
  );
};
export default SingleCollapse;
